module.exports = __webpack_public_path__ + "media/images/writer/user_extension_notification_mailer/sound_effect-326acd6c116b27599ebf8365579929d4.png";